import React, { useState } from 'react'
import { defaultSingleChatPic } from '../ChatController'
import IconToolTip from '../../../common/IconToolTip'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { CLOSE_CHAT_MODAL_SUCCESS, TAKE_CHAT_AT_FIRST_POSITION } from '../../../types/chat';
import ProfileImage from '../components/ProfileImage';
import { motion } from 'framer-motion';

const List = ({ sidebarChats = [] }) => {
    const [isChatOpen, setIsChatOpen] = useState(false)
    const dispatch = useDispatch();
    let conversationImage = defaultSingleChatPic
    const handleChatArrowClick = () => setIsChatOpen(!isChatOpen);
    const chatDetails = useSelector(state => state.chat.chatDetails);
    const serviceRequestData = useSelector((state) => state.serviceRequest.serviceRequestData);
    const openedChatBoxData = useSelector((state) => state.chat.openedChatBoxData);

    const onOpenChat = (chatId) => {
        dispatch({ type: TAKE_CHAT_AT_FIRST_POSITION, payload: { chatId } })
    }


    const handleCloseAllChats = () => {
        dispatch({ type: CLOSE_CHAT_MODAL_SUCCESS, payload: openedChatBoxData.map(({ chatId }) => chatId) });
    };

    if (sidebarChats.length === 0) return null;

    return (
        <div className='fixed right-4 bottom-4 w-[22rem] shadow-lg rounded-xl bg-white overflow-hidden z-50'>
            <div
                className='flex items-center justify-between px-4 py-3 bg-gray-700 text-white cursor-pointer'
                onClick={handleChatArrowClick}
            >
                <div className='flex items-center space-x-3'>
                    <ProfileImage
                        imgUrl={conversationImage}
                        className='w-10 h-10 rounded-full object-cover ring-2 ring-white/50'
                    />
                    <div className='flex items-center space-x-2'>
                        <span className='font-semibold text-lg'>Messaging</span>
                        {openedChatBoxData.length > 0 && (
                            <span className='px-2 py-1 text-sm bg-white/20 rounded-full'>
                                {sidebarChats.length}
                            </span>
                        )}
                    </div>
                </div>
                <div className='flex items-center space-x-2'>
                    <button
                        className='p-1.5 hover:bg-white/20 rounded-full transition-colors'
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCloseAllChats();
                        }}
                    >
                        <span className="material-icons text-xl">clear</span>
                    </button>
                    <button className='p-1.5 hover:bg-white/20 rounded-full transition-colors'>
                        <span className="material-icons text-xl">
                            {isChatOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
                        </span>
                    </button>
                </div>
            </div>

            {isChatOpen && (
                <motion.div
                    className='max-h-[500px] overflow-y-auto'
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                    {sidebarChats.map(({ chatId }) => {
                        const chat = chatDetails && chatDetails[chatId]
                        const ticket = serviceRequestData && serviceRequestData[chatId];
                        let fe;
                        if (ticket && ticket.agents) {
                            fe = ticket.agents.find((agent) => agent.role === 'FE');
                        };

                        return (
                            <motion.div
                                key={chatId}
                                className="px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer border-b border-gray-100 last:border-0"
                                onClick={() => onOpenChat(chatId)}
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.2 }}
                            >
                                <div className="flex items-center space-x-3">
                                    <IconToolTip title={chat.title}>
                                        <ProfileImage
                                            imgUrl={chat.icon}
                                            className='w-12 h-12 rounded-full object-cover'
                                            type={'group'}
                                        />
                                    </IconToolTip>
                                    <div className='flex-1'>
                                        <div className='flex items-center justify-between'>
                                            <span className='font-medium text-gray-900'>{chat.title}</span>
                                            {chat.unread_count > 0 && (
                                                <span className='px-2 py-1 text-sm bg-indigo-500 text-white rounded-full'>
                                                    {chat.unread_count}
                                                </span>
                                            )}
                                        </div>
                                        {fe && (
                                            <span className='text-sm text-gray-500'>
                                                {fe.agent.display_name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        );
                    })}
                </motion.div>
            )}
        </div>
    );
}

export default List;
